<template>
    <div>
        <div>
            <div v-for="item in templates" :key="item._id">
                <div v-show="editedItem != item._id" class="template">
                    <h5 ><span>Temat: </span>{{item.topic}}</h5>
                    <p><span>Treść komunikatu: </span>{{item.message}}</p>
                    <div class="buttons" v-show="confirmation != item._id">
                        <b-button class="button" v-on:click="editTemplate(item._id, item.topic, item.message)">Edytuj</b-button>
                        <b-button class="button" v-on:click="delTemplate(item._id)">Usuń</b-button>
                    </div>
                    <div v-if="confirmation === item._id" class="confirm">Czy napewno chcesz usunąć ten komunikat ?
                        <b-button class="button" v-on:click="confirmDelTemplate(item._id)">Tak</b-button>
                        <b-button class="button" v-on:click="cancelDelMessage()">Nie</b-button>
                    </div>
                </div>
                <div v-if="editedItem == item._id" class="template">
                    <h5 ><span>Temat: </span><b-input v-model="topicToEdit"></b-input></h5>
                    <p><span>Treść komunikatu: </span><b-input v-model="messageToEdit"></b-input></p>
                    <div class="buttons">
                        <b-button class="button" v-on:click="applyChanges(item._id, topicToEdit, messageToEdit)">Zatwierdź</b-button>
                        <b-button class="button" v-on:click="cancelChanges(item._id)">Anuluj</b-button>
                    </div>
                </div>
            </div>
            <b-button v-show="!newPost" class="button" v-on:click="addPost()">Dodaj komunikat</b-button>
            <div v-show="newPost" class="template">
                <h5 ><span>Temat: </span><b-input v-model="newTopic" placeholder="max 60 znaków"></b-input></h5>
                <p><span>Treść komunikatu: </span><b-input v-model="newMessage" placeholder="max 320 znaków"></b-input></p>
                <div class="buttons">
                    <b-button class="button" v-on:click="sendPost()">Zatwierdź</b-button>
                    <b-button class="button" v-on:click="cancelAdding()">Anuluj</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {path} from '../../../config';
export default {
    name: 'TemplatesCMS',
    methods: {
        editTemplate: function(id, topic, message){
            this.editedItem = id;
            this.topicToEdit = topic;
            this.messageToEdit = message;
        },
        delTemplate: async function(id){
            this.confirmation = id;
            this.editedItem = '';
        },
        confirmDelTemplate: async function(id){
            await axios
                .delete(`${path}templates/${id}`)
                .then(r => console.log(r.status))
                .catch(e => console.log(e));
            console.log('message deleted')
            this.$emit('shutMessages', 'Usunięto komunikat');
        },
        cancelDelMessage: function() {
            this.confirmation = '';
        },
        applyChanges: function(id, topic, message){
            this.editedItem = '';
            const payload = {
                topic: topic,
                message: message,
                author: this.userData.name,
            } 
            axios
                .put(`${path}templates/${id}`, payload)
                .then(r => console.log(r.status))
                .catch(e => console.log(e));
            this.changeTemplates(id);
        },
        cancelChanges: function(){
            this.editedItem = '';
        },
        cancelAdding: function(){
            this.newPost = false;
            this.newTopic = '';
            this.newMessage = '';
        },
        changeTemplates: function(id){
            for(let item of this.templates){
                if(item._id === id){
                    item.topic = this.topicToEdit;
                    item.message = this.messageToEdit;
                }
            }
        },
        addPost: function(){
            this.newPost = true;
        },
        sendPost: async function(){
            const payload = {
                topic: this.newTopic,
                message: this.newMessage,
                author: this.userData.name,
            } 
            await axios
                .post(`${path}templates`, payload)
                .then(r => console.log(r.status))
                .catch(e => console.log(e));
            this.newPost = false;
            console.log('message sent')
            this.$emit('shutMessages', 'Dodano nowy komunikat');
        },
    },
    props:['dbTemplates', 'userData'],
    data: function(){
        return{
            templates: this.dbTemplates,
            editedItem: '',
            topicToEdit: '',
            messageToEdit: '',
            newPost: false,
            newTopic: '',
            newMessage: '',
            confirmation: '',
        }
    }
}
</script>
<style lang="scss" scoped>
    .template {
        border-top: solid;
        border-bottom: solid;
        border-color: blue;
        border-width: 2px;
        border-radius: 10px;
        margin-bottom: 5px;
        text-align: left;
        padding-left: 10px;
        .buttons {
            display: flex;
            justify-content: space-evenly;
            margin-bottom: 5px;
        }
        span {
            font-weight: bold;
        }
    }
    .confirm{
        background-color: red;
        margin: 10px 0;
        border-radius: 10px;
        color: white;
        padding: 0 5px;
        .button {
            margin: 5px;
        }
    }
</style>